module.exports = "<component v-bind:is=\"currentPage.viewAs\"></component>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/template.html
// module id = 88
// module chunks = 0